import { render, staticRenderFns } from "./InfopointActions.vue?vue&type=template&id=60bfdfc3&scoped=true"
import script from "./InfopointActions.vue?vue&type=script&lang=js"
export * from "./InfopointActions.vue?vue&type=script&lang=js"
import style0 from "./InfopointActions.vue?vue&type=style&index=0&id=60bfdfc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bfdfc3",
  null
  
)

export default component.exports